function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var FlankTemplate = require('./flank.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var FlankOverlay = /*#__PURE__*/function () {
  function FlankOverlay(app, mod, c1, c2, c3) {
    _classCallCheck(this, FlankOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod, true, false, false);
  }
  return _createClass(FlankOverlay, [{
    key: "remove",
    value: function remove() {
      this.overlay.remove();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      var overlay_zindex = parseInt(this.overlay.zIndex);
      var hud = document.getElementById('game-hud2');
      if (hud) {
        hud.style.zIndex = overlay_zindex + 1;
      }
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      //
      // push GAME HUD under overlay
      //
      var overlay_zindex = parseInt(this.overlay.zIndex);
      var hud = document.getElementById('game-hud2');
      if (hud) {
        hud.style.zIndex = overlay_zindex - 2;
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.overlay.show(FlankTemplate());
      this.pushHudUnderOverlay();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }]);
}();
module.exports = FlankOverlay;